import type { AnalysisFamily } from "../../api/types.js";

export const STATIC_SCAN_FAMILIES = [
  "sast",
  "secrets",
  "sca",
  "iac",
  "container",
  "pqc",
] as const satisfies readonly AnalysisFamily[];

export type StaticScanFamily = (typeof STATIC_SCAN_FAMILIES)[number];

export interface ScanFamilyOption {
  id: StaticScanFamily | "dast" | "remediation" | "runtime_defense_feedback";
  label: string;
  detail: string;
  selectable: boolean;
}

export const SCAN_FAMILY_OPTIONS: readonly ScanFamilyOption[] = [
  {
    id: "sast",
    label: "SAST",
    detail: "Injection, SSRF, eval, access control, and language sinks",
    selectable: true,
  },
  {
    id: "secrets",
    label: "Secrets",
    detail: "Hardcoded credentials and git-history fingerprints",
    selectable: true,
  },
  {
    id: "sca",
    label: "SCA",
    detail: "Advisories, licenses, lockfiles, and SBOM",
    selectable: true,
  },
  {
    id: "iac",
    label: "IaC",
    detail: "Terraform, Kubernetes, and CloudFormation policy",
    selectable: true,
  },
  {
    id: "container",
    label: "Container",
    detail: "Dockerfile and image policy",
    selectable: true,
  },
  {
    id: "pqc",
    label: "PQC",
    detail: "Classical crypto inventory and CBOM readiness",
    selectable: true,
  },
  {
    id: "dast",
    label: "DAST",
    detail: "Not available on this static console",
    selectable: false,
  },
  {
    id: "remediation",
    label: "Remediation",
    detail: "Governed after findings exist; not a scan pass",
    selectable: false,
  },
  {
    id: "runtime_defense_feedback",
    label: "Runtime feedback",
    detail: "Not available on this static console",
    selectable: false,
  },
];

export const DEFAULT_SCAN_FAMILIES: readonly StaticScanFamily[] = STATIC_SCAN_FAMILIES;

export function toggleScanFamily(
  selected: readonly StaticScanFamily[],
  family: StaticScanFamily,
): StaticScanFamily[] {
  if (selected.includes(family)) {
    const next = selected.filter((item) => item !== family);
    return next.length > 0 ? next : [...selected];
  }
  return STATIC_SCAN_FAMILIES.filter((item) => item === family || selected.includes(item));
}
